import React, { useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

import type { Dispatch, SetStateAction } from "react";
import type { ScrollBarProps } from "react-perfect-scrollbar";

import "react-perfect-scrollbar/dist/css/styles.css";

const ScrollContainer: React.FC<ScrollBarProps> = (props) => {
  const [onXReachEnd, setOnXReachEnd] =
    useState<(container: HTMLElement) => void | undefined>();
  const { children, options = { suppressScrollX: true }, ...restProps } = props;

  const showScrollBarX = (
    setState: Dispatch<
      SetStateAction<((container: HTMLElement) => void) | undefined>
    >,
  ): void => {
    setTimeout(() => {
      setState((): void => {
        return;
      });
    }, 500);
  };

  useEffect(() => {
    showScrollBarX(setOnXReachEnd);
  }, []);

  return (
    <PerfectScrollbar
      onXReachEnd={props.onXReachEnd || onXReachEnd}
      options={options}
      {...restProps}
    >
      {children}
    </PerfectScrollbar>
  );
};

export default ScrollContainer;
